import { Ajax } from "./Ajax";
import { Auth } from "./Auth";
import { Helper } from "./Helper";
import { Components } from "./Components";
import { Format } from "./Format";
import { Url } from "./Url";
import { View } from "./View";
import * as StringPoly from './StringPoly';

export const AppUtils = {
	Ajax,
	Auth,
	Helper,
	Components,
	Url,
	View,
	Format,
	StringPoly
};

/**
 * By default store url in jqXHR object for error logging.
 * If beforeSend is overwritten in the ajax request the following logic is not applied and must be applied manually.
 */
jQuery.ajaxSetup( /* istanbul ignore next: no actual Ajax calls are made */ {
	beforeSend: AppUtils.Ajax.beforeSend
});
